import { ORDER_STATUS } from "./order-management";

export const ORDER_INFORMATION_INPUT_FIELDS = (t, isExpedited = false) => {
  const allOrderInputs = [
    {
      id: 15,
      isOptional: true,
      label: "invoiceNumber",
      placeholder: t("invoiceNumberPlaceholder"),
      type: "text",
    },
    {
      id: 0,
      label: "receiverPhoneNumber",
      placeholder: "770000000",
      type: "tel",
    },
    {
      id: 1,
      label: "receiverFullName",
      placeholder: t("receiverFullName"),
      type: "text",
    },
    {
      id: 2,
      isOptional: true,
      label: "secondPhoneNumber",
      placeholder: "770000000",
      type: "tel",
    },
    {
      allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
      id: 3,
      label: "shipmentSchedule",
      placeholder: "DD/MM/YYYY",
      type: "schedule",
    },
    {
      allowedStatuses: [
        ORDER_STATUS.DRAFT,
        ORDER_STATUS.INCOMPLETE_DATA,
        ORDER_STATUS.FAILED,
      ],
      id: 8,
      label: "receiverWhatsApp",
      placeholder: "770000000",
      type: "tel",
    },
    {
      allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
      id: 4,
      isSearchable: true,
      label: "pickupLocation",
      path: "location-mgmt/sender/getlocations?isActive=true",
      type: "select",
    },
    {
      allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
      id: 5,
      isSearchable: false,
      label: "dropOffLocation",
      path: "location-mgmt/sender/getreceiverlocations?receiverId=",
      type: "select",
    },
    {
      allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
      id: 6,
      label: "contactPhoneNumber",
      placeholder: "770000000",
      type: "tel",
    },
    {
      allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
      fieldOptions: [],
      id: 7,
      isSearchable: true,
      label: "contactName",
      placeholder: t("chooseContact"),
      type: "select",
    },
  ];

  // shipmentSchedule is located at index 4 in the array above.
  // Remove the shipmentSchedule input for expedited orders.
  if (isExpedited) allOrderInputs.splice(4, 1);

  return allOrderInputs;
};

export const SHIPMENT_DETAILS_INPUT_FIELDS = (t) => [
  {
    allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
    id: 9,
    label: "quantity",
    placeholder: "1",
    type: "text",
  },
  {
    allowedStatuses: [ORDER_STATUS.DRAFT, ORDER_STATUS.INCOMPLETE_DATA],
    id: 8,
    isSearchable: false,
    label: "preferredVehicleType",
    path: "order-mgmt/vehicletype",
    type: "checkBox",
  },
  {
    allowedStatuses: [
      ORDER_STATUS.DRAFT,
      ORDER_STATUS.INCOMPLETE_DATA,
      ORDER_STATUS.AWAITING_SELECTION,
      ORDER_STATUS.PENDING_PICKUP,
      ORDER_STATUS.PICKUP_STARTED,
      ORDER_STATUS.ARRIVED_AT_PICKUP,
      ORDER_STATUS.ORDER_COLLECTED,
    ],
    id: 12,
    label: "orderFees",
    placeholder: "13 JD",
    type: "text",
  },
  {
    allowedStatuses: [
      ORDER_STATUS.DRAFT,
      ORDER_STATUS.INCOMPLETE_DATA,
      ORDER_STATUS.AWAITING_SELECTION,
    ],
    id: 13,
    label: "deliveryFees",
    placeholder: t("deliveryFeesPlaceHolder"),
    toolTipMessage: "Tooltip message",
    type: "checkBox",
  },
  {
    allowedStatuses: [
      ORDER_STATUS.DRAFT,
      ORDER_STATUS.INCOMPLETE_DATA,
      ORDER_STATUS.PENDING_PICKUP,
      ORDER_STATUS.ORDER_OUT_FOR_DELIVERY,
    ],
    gridColumns: 6,
    id: 14,
    isOptional: true,
    label: "notes",
    placeholder: t("note"),
    type: "textArea",
  },
];

export const DELIVERY_FEES_OPTIONS = [
  {
    id: 0,
    label: "Sender",
    toolTip: "paidOptionToolTip",
  },
  {
    id: 1,
    label: "Receiver",
    toolTip: "notPaidOptionToolTip",
  },
];

export const orderCreationIdsValues = [
  "pickUpLocationId",
  "dropOffLocationId",
  "dropOffLocation",
  "pickupLocation",
  "categoryId",
  "preferredVehicleType",
  "preferredVehicleTypeId",
  "quantity",
  "goodsCategory",
  "type",
];
